import { useState } from 'react';
import {
  scoreTone,
  SCORE_FATOR_LABELS,
  type RadarOportunidade,
} from '@/pages/painel/lib/radarConstants';

interface Fator {
  pontos: number;
  max: number;
  motivo: string;
}

export default function RadarScore({ op, size = 'md' }: { op: RadarOportunidade; size?: 'sm' | 'md' }) {
  const [open, setOpen] = useState(false);
  const score = op.hop_score ?? 0;
  const tone = scoreTone(score);
  const fatores = (op.score_fatores ?? {}) as Record<string, Fator>;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="group inline-flex items-center gap-1.5 cursor-pointer"
        title="Ver por que esta oportunidade recebeu este score"
      >
        <span
          className={`inline-flex items-center justify-center font-bold rounded-full border ${tone.tone} ${
            size === 'md' ? 'w-10 h-10 text-sm' : 'w-8 h-8 text-xs'
          }`}
        >
          {score}
        </span>
        <span className="text-[11px] text-gray-400 group-hover:text-[#E8610A] whitespace-nowrap">
          <i className="ri-question-line"></i> Por quê?
        </span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={() => setOpen(false)}>
          <div
            className="bg-white rounded-2xl border border-gray-200 w-full max-w-md max-h-[85vh] overflow-y-auto shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-white px-5 py-4 border-b border-gray-100 flex items-center justify-between">
              <div>
                <h3 className="font-bold text-gray-900 text-sm">Por que este score?</h3>
                <p className="text-xs text-gray-500">Fórmula transparente do HOP Radar Score</p>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>

            <div className="p-5 space-y-4">
              <div className="flex items-center justify-between bg-gray-50 rounded-xl p-4">
                <div className="flex items-center gap-3">
                  <span className={`inline-flex items-center justify-center w-12 h-12 font-bold rounded-full border text-base ${tone.tone}`}>
                    {score}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-gray-900">{tone.label}</p>
                    <p className="text-xs text-gray-500">Total de 100 pontos</p>
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                {Object.entries(SCORE_FATOR_LABELS).map(([key, label]) => {
                  const f = fatores[key] as Fator | undefined;
                  const pontos = f?.pontos ?? 0;
                  const max = f?.max ?? 0;
                  const pct = max > 0 ? (pontos / max) * 100 : 0;
                  return (
                    <div key={key} className="border border-gray-100 rounded-xl p-3">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm font-semibold text-gray-700">{label}</span>
                        <span className="text-xs font-bold text-gray-900">
                          {pontos}/{max}
                        </span>
                      </div>
                      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                        <div className="h-full bg-[#E8610A] rounded-full" style={{ width: `${pct}%` }} />
                      </div>
                      <p className="text-xs text-gray-500 mt-1.5 leading-relaxed">{f?.motivo ?? 'Sem informação para avaliar'}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}